import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'

import { CommonHelper } from '../../../helpers/common-helper'
import { EventsNames } from '../../../helpers/events-names'
import { IUserSession } from '../../../helpers/user-session'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { PopupType } from './../../../helpers/popup-manager'

import { Enums } from '../../../models/common/enums'
import { IOpObject } from '../../../models/util/interfaces'
import { LoggerService } from '../../common/common.module'
import { OpLocation } from '../../../models/core/op-location'

import { GroupingLocationTypeHelper } from '../grouping-locations-types.helper'
import { OpLocationType } from '../../../models/core/op-location-type';

interface GroupingLocationTypeCreateEditScope extends CreateEditScope {}

export class GroupingLocationTypeCreateEditController extends CreateEditController {

    // Members

    private locationTypeBusinessObject: any

    // Members End


    constructor(
        private $scope: GroupingLocationTypeCreateEditScope,
        private $q: ng.IQService, 
        private $timeout: ng.ITimeoutService,
        private logger: LoggerService,
        protected userSession: IUserSession,
        referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }


    // Events

    private onInit(args: any[]): void {
        if (args && args[0]) {
            const createEditInitParams: CreateEditInitParams = args[0]

            this.locationTypeBusinessObject = createEditInitParams ? createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)
            
            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<IOpObject>  {
        const deferred = this.$q.defer<IOpObject>()

        GroupingLocationTypeHelper
            .saveGroupingLocationType(this.userSession.getDataProvider(), this.locationTypeBusinessObject, GroupingLocationTypeHelper.createOpLocationTypeFromOpObject(objectToSave))
            .then((savedObject: OpLocationType) => {
                CommonHelper.openInfoPopup(LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName))
                CommonHelper.setValueToLocalStorage(CommonHelper.localStorageVarForSavedEntity.groupingLocationTypeSaved, true, 0)
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject as any)
            })
            .fail((error: any) => {
                this.logger.log(error)

                CommonHelper.openInfoPopup(error, 'error', 5000)

                deferred.reject()
            })

        return deferred.promise
    }

    private onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()

        return deferred.promise
    }

    // Events End


    // Setup

    private setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName), 
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )
    }

    private setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.options = {
            title: '',
            type: null,
            referenceType: this.referenceType,
            onSave: (objectToSave: IOpObject) => this.onSave(objectToSave),
            onBulkSave: null,
            onSubmit: null,
            onClose: null,
            submitBulkEdit: null,
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.groupingLocationTypeSaved,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
        }
    }

    // Setup End
}